import Swiper from 'swiper';
import Parallax from 'parallax-js';

let swiperHome = {
    init() {
        var swiper = new Swiper('.swiper-container.swiper-top', {
            loop: true,
            autoplay: {
                delay: 3000,
            },
        });


        $('.menu-home li').hover(function(){
            var id = $(this).attr('id');
            $('.'+id).addClass('active');
            $('.swiper-top').addClass('blur');
            $('h1').addClass('blur');
            $('.titre').addClass('blur');

        }, function() {
            $('.barre').removeClass('active');
            $('.swiper-top').removeClass('blur');
            $('h1').removeClass('blur');
            $('.titre').removeClass('blur');
        })


        var scene = document.getElementById('scene');
        var element = document.getElementById('slider-top');
        //var parallaxInstance = new Parallax(scene);
        var parallaxInstance = new Parallax(scene, {
            inputElement: element
        });


        $('.fade-video').delay(4000).fadeOut(1000);

    }
}

export default swiperHome;
